export function useRedirectIfEmpty(value: any) {
  if (!value) {
    throw createError({ fatal: true, statusCode: 404 });
  }
}
